import { DependencyInjectionContainer } from "./dependency-injection-container";
import { TileCollection } from "../blueprint/dashboards/entities/tile-collection";

const TileCollectionKey = "tileCollection";

export const getTileCollection = () => {
  return DependencyInjectionContainer.getInstance().resolve<TileCollection>(
    TileCollectionKey,
  );
};

export const registerTileCollection = () => {
  DependencyInjectionContainer.getInstance().register(
    TileCollectionKey,
    TileCollection,
  );
};
